import React from 'react';
import {resolveFactionSkinIconPath} from '../../utils/factions/resolveFactionSkinIconPath';
import RankSkinFrame from './RankSkinFrame';
import './FactionSkinIcon.css';

/**
 * Иконка фракции игрока с рамкой рейтингового образа поверх нее.
 *
 * Это замена одиночного <img src={resolveFactionSkinIconPath(...)}> в тех
 * местах, где иконка рисуется не общим PlayerFactionIcon (у того рамка уже
 * своя). Обертка нужна только как опора для абсолютной рамки, поэтому она
 * inline-flex и без собственных отступов — в родительской верстке ведет себя
 * как сама картинка.
 *
 * @param {Object} props
 * @param {string} props.factionId
 * @param {string} [props.skinId] - образ игрока; от него зависит и иконка, и рамка
 * @param {string} [props.className] - класс обертки (позиционирование, размер)
 * @param {string} [props.imgClassName] - класс самой картинки, как было у <img>
 */
const FactionSkinIcon = ({
  factionId, skinId, className = '', imgClassName = '', alt = '', title, onClick, style,
}) => (
  <span className={`faction-skin-icon ${className}`} title={title} onClick={onClick} style={style}>
    <img className={imgClassName} src={resolveFactionSkinIconPath(factionId, skinId)} alt={alt}/>
    <RankSkinFrame skinId={skinId}/>
  </span>
);

export default FactionSkinIcon;
